import React from 'react';
import styles from '../../static/css/pages.module.css';
import Title from "../../components/title/title";
import Icon from "../../components/icons/icons";
import axios from "axios";
import ieSvg from "../../components/icons/ieSvg";

class ServerRegister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: '',
      message: ''
    };
  }

  componentDidMount() {
    ieSvg();
  }

  handleRegister = () => {
    let preloader = document.getElementById("preloader");
    preloader.style.display = "block";
    console.log(process.env.REACT_APP_GATE + 'registration/stage/reset')
    axios.post(process.env.REACT_APP_GATE + 'registration/stage/reset', '')
      .then((response) => {
        this.setState({status: response.data.result.status, message: response.data.result.errorMessage})
        preloader.style.display = "none";
      })
      .catch(error => {
        window.location=process.env.PUBLIC_URL + "/error";
      })
  }

  render() {
    switch (this.state.status) {
      case "AUTH_FAILED":
        return window.location.href = process.env.REACT_APP_ELF_URL + '?login=true';
      case "SUCCESS":
        return window.location.href = process.env.PUBLIC_URL;
      case "TIMEOUT":
        return (
          <React.Fragment>
            {this.props.pageTitle ?
              <div className={styles.content}>
                <div>
                  <div className="l-grid_pt-8 mobile_l-grid">
                    <div className="l-grid__item_1"></div>
                    <div className="l-grid__item_6 mobile_l-grid__item_10">
                      <Title icon={this.props.pageIcon} title={this.props.pageTitle}/>
                      <div className="l-align_center">
                        <div className={styles.serviceIcon}>
                          <Icon name="icon_error-data" viewbox="0 0 227 120" />
                        </div>
                        Данные не получены.<br />
                        Повторите операцию позже.
                        <div className={styles.article}>&nbsp;</div>
                        <div className={styles.article}>&nbsp;</div>
                        <div className={styles.article}>&nbsp;</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              :
              <div className="l-align_center">
                <div className={styles.serviceIcon}>
                  <Icon name="icon_error-data" viewbox="0 0 227 120" />
                </div>
                Данные не получены.<br />
                Повторите операцию позже.
                <div className={styles.article}>&nbsp;</div>
                <div className={styles.article}>&nbsp;</div>
                <div className={styles.article}>&nbsp;</div>
              </div>
            }
          </React.Fragment>
        );
      case "ERROR":
        return (
          <React.Fragment>
            {this.props.pageTitle ?
              <div className={styles.content}>
                <div>
                  <div className="l-grid_pt-8 mobile_l-grid">
                    <div className="l-grid__item_1"></div>
                    <div className="l-grid__item_6 mobile_l-grid__item_10">
                      <Title icon={this.props.pageIcon} title={this.props.pageTitle}/>
                      <div className="l-align_center">
                        <div className={styles.serviceIcon}>
                          <Icon name="icon_error-data" viewbox="0 0 227 120"/>
                        </div>
                        Данные не получены.<br/>
                        {this.state.message}
                        <div className={styles.article}>&nbsp;</div>
                        <div className={styles.article}>&nbsp;</div>
                        <div className={styles.article}>&nbsp;</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              :
              <div className="l-align_center">
                <div className={styles.serviceIcon}>
                  <Icon name="icon_error-data" viewbox="0 0 227 120"/>
                </div>
                Данные не получены.<br/>
                {this.state.message}
                <div className={styles.article}>&nbsp;</div>
                <div className={styles.article}>&nbsp;</div>
                <div className={styles.article}>&nbsp;</div>
              </div>
            }
          </React.Fragment>
        );
      default:
        return (
          <React.Fragment>
            {this.props.pageTitle ?
              <div className={styles.content}>
                <div>
                  <div className="l-grid_pt-8 mobile_l-grid">
                    <div className="l-grid__item_1"></div>
                    <div className="l-grid__item_6 mobile_l-grid__item_10">
                      <Title icon={this.props.pageIcon} title={this.props.pageTitle}/>
                      <div className="l-align_center">
                        <div className={styles.serviceIcon}>
                          <Icon name="icon_error-data" viewbox="0 0 227 120" />
                        </div>
                        Данные не получены.<br />
                        <div>{this.props.errorMessage}</div>
                        Для продолжения работы <span className={styles.link} onClick={this.handleRegister}>зарегистрируйтесь</span>.
                        <div className={styles.article}>&nbsp;</div>
                        <div className={styles.article}>&nbsp;</div>
                        <div className={styles.article}>&nbsp;</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              :
              <div className="l-align_center">
                <div className={styles.serviceIcon}>
                  <Icon name="icon_error-data" viewbox="0 0 227 120" />
                </div>
                Данные не получены.<br />
                <div>{this.props.errorMessage}</div>
                Для продолжения работы <span className={styles.link} onClick={this.handleRegister}>зарегистрируйтесь</span>.
                <div className={styles.article}>&nbsp;</div>
                <div className={styles.article}>&nbsp;</div>
                <div className={styles.article}>&nbsp;</div>
              </div>
            }
          </React.Fragment>
        );
    }

  }
}

export default ServerRegister;